module.exports = __webpack_public_path__ + "static/img/12.e857052.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/eng/12.png
// module id = ++30
// module chunks = 0